/**
 * Team member status for the admin portal team management table
 * Uses `as const` object with derived union type (no enums per TypeScript standards)
 */
const TEAM_MEMBER_STATUS = {
    ALL: 'all',
    ACTIVE: 'active',
    PENDING: 'pending',
    INACTIVE: 'inactive',
};

export { TEAM_MEMBER_STATUS };
//# sourceMappingURL=TeamMemberStatus.js.map
